// extracted by mini-css-extract-plugin
export default {"scoringRuleRow":"MTIq8LXP4J0huV_cIoiz","scoringRuleButton":"MEqk5JNmFiPAXbUzxQnQ","descriptionRow":"n0AmamQ1t1E3jkJAPVtN","bold":"OcEEcLpz_kbZYjKgkW3g"};